module.exports = __webpack_public_path__ + "img/222.7cb5c4ae.png";